import { render, staticRenderFns } from "./ApplyPass.vue?vue&type=template&id=b65f4ed6&scoped=true&"
import script from "./ApplyPass.vue?vue&type=script&lang=js&"
export * from "./ApplyPass.vue?vue&type=script&lang=js&"
import style0 from "./ApplyPass.vue?vue&type=style&index=0&id=b65f4ed6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65f4ed6",
  null
  
)

export default component.exports